// extracted by mini-css-extract-plugin
export default {"entry":"history_entry___entry___d3a2a5e1","entryContent":"history_entry___entryContent___c12f6916","title":"history_entry___title___d09b31e3"};